import { isOwnContact } from './homeCityPrompt';

// Same prefilter as backend services/name_hygiene.py is_suspicious_name.
// Recall-first: a hit means the name might hide a memory jog. The existing
// name clean-up job decides what is actually a note.

const RELATIONSHIP_WORDS = [
  'mom', 'mum', 'mommy', 'mummy', 'mother', 'dad', 'daddy', 'father',
  'bro', 'brother', 'sis', 'sister', 'aunt', 'auntie', 'uncle', 'cousin',
  'grandma', 'grandpa', 'granny', 'nana', 'papa', 'oma', 'opa',
  'wife', 'husband', 'hubby', 'gf', 'bf', 'boyfriend', 'girlfriend',
  'fiance', 'fiancee', 'ex', 'neighbor', 'neighbour', 'roommate',
  'landlord', 'landlady', 'tenant', 'boss', 'coworker', 'colleague',
  'friend', 'buddy', 'son', 'daughter', 'nephew', 'niece', 'inlaw',
  'stepmom', 'stepdad', 'godmother', 'godfather',
];
const PROFESSION_WORDS = [
  'plumber', 'electrician', 'dentist', 'doctor', 'nurse', 'barber',
  'hairdresser', 'stylist', 'realtor', 'mechanic', 'painter', 'cleaner',
  'nanny', 'babysitter', 'sitter', 'tutor', 'coach', 'trainer', 'lawyer',
  'attorney', 'accountant', 'agent', 'contractor', 'handyman', 'gardener',
  'landscaper', 'driver', 'uber', 'lyft', 'taxi', 'vet', 'therapist',
  'masseuse', 'chiropractor', 'photographer', 'dj', 'caterer', 'roofer',
  'mover', 'welder', 'tailor', 'optician', 'pharmacist', 'banker',
  'broker', 'inspector', 'notary', 'locksmith', 'exterminator',
  'physio', 'dermatologist', 'optometrist', 'plow', 'dogwalker',
];
const PLACE_EVENT_WORDS = [
  'gym', 'church', 'school', 'work', 'office', 'cafe', 'coffee', 'bar',
  'club', 'party', 'wedding', 'conference', 'conf', 'meetup', 'class',
  'yoga', 'pilates', 'crossfit', 'soccer', 'hockey', 'golf', 'tennis',
  'poker', 'choir', 'camp', 'cottage', 'lake', 'pool', 'park',
  'daycare', 'airbnb', 'hotel', 'hostel', 'playgroup',
];
const MARKER_WORDS = [
  'from', 'the', 'at', 'of', 'my', 'our', 'met', 'via', 'thru',
  'through', 'next', 'door', 'upstairs', 'downstairs', 'nextdoor',
];
const SUSPECT_WORDS = new Set([
  ...RELATIONSHIP_WORDS,
  ...PROFESSION_WORDS,
  ...PLACE_EVENT_WORDS,
  ...MARKER_WORDS,
]);
const PUNCT_RE = /[()[\]{}/#@_=+*&%$~|<>0-9"]/;

export function isSuspiciousName(contact) {
  const blob = [contact?.first_name, contact?.middle_name, contact?.last_name]
    .map((part) => String(part || '').trim())
    .filter(Boolean)
    .join(' ');
  if (!blob) return false;
  if (PUNCT_RE.test(blob)) return true;
  const tokens = blob.split(/\s+/);
  if (tokens.length >= 3) return true;
  return tokens.some((token) => {
    const clean = token.toLowerCase().replace(/[^a-z']/g, '');
    if (SUSPECT_WORDS.has(clean)) return true;
    if (clean.includes("'")) {
      const tail = clean.split("'").pop();
      if (SUSPECT_WORDS.has(tail)) return true;
    }
    return false;
  });
}

export function suspiciousNameContacts(contacts, selfId) {
  return (contacts || []).filter((contact) => (
    contact && !contact.deleted_at && !isOwnContact(contact, selfId) && isSuspiciousName(contact)
  ));
}

export function shouldShowNameCleanupPrompt(contacts, selfId, dismissed) {
  if (dismissed) return false;
  return suspiciousNameContacts(contacts, selfId).length > 0;
}
